import { render, staticRenderFns } from "./DjVueCheckboxGroup.vue?vue&type=template&id=4690762f&scoped=true&"
import script from "./DjVueCheckboxGroup.vue?vue&type=script&lang=ts&"
export * from "./DjVueCheckboxGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4690762f",
  null
  
)

export default component.exports